import useStore from '../../Hooks/useStore';
import { setFilterColumn } from '../../../store/utils';
import { useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';

const useExportsController = () => {
  const [getters, setters] = useStore();
  const {
    user: { getUser },
    invoice: { getInvoice, getFormMessage, getDepositsFormMessage },
  } = getters;
  const {
    invoice: {
      deleteDeposits,
      setInvoice,
      autocompleteDeposit,
      filterDeposit,
      createDeposit,
      updateDeposit,
      validateForm,
      filterSelectCompanies,
      deleteInvoices,
      autocompleteInvoice,
      filterInvoice,
      createInvoice,
      updateInvoice,
      deleteCompanies,
      autocompleteCompany,
      filterCompany,
      createCompany,
      updateCompany,
      deleteTaxes,
      deleteLogistics,
      deleteLogisticOrigins,
      autocompleteTax,
      autocompleteLogistic,
      autocompleteLogisticOrigin,
      filterTax,
      filterLogistic,
      filterLogisticOrigin,
      createTax,
      createLogistic,
      createLogisticOrigin,
      updateTax,
      updateLogistic,
      updateLogisticOrigin,
      filterSelectTaxes,
      createDeposits,
      validateDepositsForm,
      filterInvoiceProduct,
      filterDailyDeposit,
      filterCompleteInvoice,
      filterCompleteDeposit,
      updateLockInvoice,
      updateManyDeposits,
      updateLockDeposit,
      updateDeposits,
      invoiceDashboard,
      depositDashboard,
      filterGroupInvoice,
      filterGroupDeposit,
      filterGroupLogistic,
    },
    modal: { setModal },
  } = setters;
  const location = useLocation();
  const currentRoute = location.pathname;

  const user = getUser('current_user');

  const { enqueueSnackbar } = useSnackbar();

  const companyFilter = getInvoice('filters.selectCompanies.filter');
  const selectCompanies = getInvoice('filters.selectCompanies.data.data');
  const groups = getInvoice('groups');
  const selectedGroupId = getInvoice('selectedGroupId');

  const setCompanyFilter = (filter: SearchFilter) =>
    setInvoice('filters.selectCompanies.filter', filter);

  const setCompanyFilterField = (field: string, operator?: OPERATOR) => (e) => {
    let filter = setFilterColumn(
      field,
      e.target.value,
      companyFilter,
      operator,
    );
    setCompanyFilter({
      ...filter,
      page: 1,
    });
  };

  return {
    getInvoice,
    setInvoice,
    companyFilter,
    filterDeposit,
    getFormMessage,
    createDeposit,
    updateDeposit,
    setModal,
    validateForm,
    filterSelectCompanies,
    setCompanyFilterField,
    autocompleteDeposit,
    deleteDeposits,
    location,
    currentRoute,
    enqueueSnackbar,
    deleteInvoices,
    autocompleteInvoice,
    filterInvoice,
    createInvoice,
    updateInvoice,
    deleteCompanies,
    autocompleteCompany,
    filterCompany,
    createCompany,
    updateCompany,
    deleteTaxes,
    deleteLogistics,
    deleteLogisticOrigins,
    autocompleteTax,
    autocompleteLogistic,
    autocompleteLogisticOrigin,
    filterTax,
    filterLogistic,
    filterLogisticOrigin,
    createTax,
    createLogistic,
    createLogisticOrigin,
    updateTax,
    updateLogistic,
    updateLogisticOrigin,
    filterSelectTaxes,
    selectCompanies,
    createDeposits,
    getDepositsFormMessage,
    validateDepositsForm,
    filterInvoiceProduct,
    filterDailyDeposit,
    filterCompleteInvoice,
    filterCompleteDeposit,
    updateLockInvoice,
    updateManyDeposits,
    updateLockDeposit,
    updateDeposits,
    invoiceDashboard,
    depositDashboard,
    filterGroupInvoice,
    filterGroupDeposit,
    filterGroupLogistic,
    groups,
    user,
    selectedGroupId,
  };
};

export default useExportsController;
